import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */
export var waitForTick = function waitForTick() {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, 0);
  });
};